import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { assert_array_includes } from '@shared/asserts/utils_asserts';
import { useLocation, useNavigate } from 'react-router-dom';
import { UI_PRIMITIVE__tooltip } from '../../../../components/ui/UI_PRIMITIVE__tooltip';
import { PROPS__button_navigation } from '../button_wrappers/PROPS__button_navigation';

export function ButtonNavigationMobile({ page_type, tooltip_title, Icon, disabled }: PROPS__button_navigation) {
  const navigate = useNavigate();
  const location = useLocation();

  let is_page_opened = location.pathname.includes(page_type);

  assert_array_includes(Object.values(ENUM__page_type), page_type);

  /*
   * EVENTS
   */
  async function onClick() {
    // Use navigate to update the URL without reloading
    await navigate(page_type);
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */
  return (
    <div className={`relative w-full py-2 ${is_page_opened ? 'bg-component rounded-2xl' : ''} `}>
      <UI_PRIMITIVE__tooltip tooltip_title={tooltip_title}>
        <UI_PRIMITIVE__button
          variant="no-border-on-page"
          className="text-lg w-full justify-start"
          onClick={() => onClick()}
          disabled={is_page_opened || disabled}
        >
          <Icon />
          {tooltip_title}
        </UI_PRIMITIVE__button>
      </UI_PRIMITIVE__tooltip>
    </div>
  );
}
